import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetCollectionTriageNextV2Request } from './get-collection-triage-next-v2-request';
import type { IGetCollectionTriageNextV2Response } from './get-collection-triage-next-v2-response';
import { getCollectionTriageNextV2ResponseSchema } from './get-collection-triage-next-v2-response';

/**
 * @deprecated Superseded by `getCollectionTriageNextV3Api`. Frozen, not deleted -
 * an old app binary may still call it. See "Web-only / orphan versions pending
 * deletion" in apps/api/CLAUDE.md.
 */
export async function getCollectionTriageNextV2Api({
  collectionId,
}: IGetCollectionTriageNextV2Request): Promise<
  IValidatedResponse<IGetCollectionTriageNextV2Response>
> {
  return getRequest<IGetCollectionTriageNextV2Response>({
    path: `/sys/collections/${collectionId}/triage/next/v2`,
    schema: getCollectionTriageNextV2ResponseSchema,
  });
}
